import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'rw',
    fullName: 'Kinyarwanda',
    nativeName: 'Ikinyarwanda',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Ikintu gitangaje kiraza",
    landing_subtitle: "ArgVoid ni porogaramu na sitidiyo yo guteza imbere umukino. Mukomereze aho, ibintu bishya biraza vuba!",
    select_language: "Hitamo Ururimi",
    search_placeholder: "Shakisha indimi ...",
    terms_title: "Amasezerano ya serivisi",
    policy_title: "Politiki Yibanga",
    cookies_title: "Politiki ya kuki",
    terms_content: `
        <strong>1. Kwemera Amategeko</strong><br>
        Mugushikira ArgVoid, aya Masezerano ya Serivisi aremewe. Niba aya magambo atemewe, serivisi ntigomba gukoreshwa.<br><br>

        <strong>2. Ikoreshwa rya platform</strong><br>
        ArgVoid nibisabwa byatanzwe "nkuko biri" kubikorwa byo gutanga amakuru no guhanga. Serivisi igomba gukoreshwa gusa mubikorwa byemewe.<br><br>

        <strong>3. Imyitwarire yabujijwe</strong><br>
        Gucukumbura intege nke zurubuga, spam, cyangwa kugerageza kwinjira mubikorwa bitemewe kubikorwa remezo birabujijwe rwose.<br><br>

        <strong>4. Kwamagana</strong><br>
        Ihuriro na serivisi birashobora guhinduka igihe icyo ari cyo cyose nta nteguza. Nta garanti yatanzwe kubyerekeye igihe cyangwa serivisi iboneka.
    `,
    policy_content: `
        <strong>1. Ikusanyamakuru</strong><br>
        Ihuriro ntirisaba kwemeza abakoresha cyangwa gushiraho konti muriki gihe. Nta makuru yihariye yumuntu (nkamazina cyangwa aderesi imeri) yakusanyirijwe mubashyitsi.<br><br>

        <strong>2. Gukoresha Data</strong><br>
        Shingiro, isesengura ritamenyekanye rishobora gukusanywa kugirango wumve urujya n'uruza rwurubuga no kunoza porogaramu. Aya makuru ntaho ahuriye numuntu ukoresha.<br><br>

        <strong>3. Serivisi-Yagatatu</strong><br>
        Abandi-batanga isoko barashobora gukoreshwa muri serivise zo kwakira no gusesengura. Imikorere yi banga yabatanga itanga amakuru atazwi yatunganijwe kubikorwa remezo.<br><br>

        <strong>4. Umutekano wamakuru</strong><br>
        Ingamba zumutekano zifatika zishyirwa mubikorwa kurinda urubuga. Ariko, nta buryo bwo kohereza kuri interineti butekanye rwose.<br><br>
    `,
    cookies_content: `
        <strong>1. Cookies nububiko bwaho ni iki? </strong><br>
        Cookies hamwe na mushakisha ububiko bwaho ni dosiye ntoya yabitswe kubikoresho kugirango wibuke ibyifuzo byimiterere mugusura.<br><br>

        <strong>2. Gukoresha Intego</strong><br>
        Browser LocalStorage ikoreshwa cyane kugirango ubike igenamiterere, nka: <br>
        - Ibyifuzo byururimi<br>
        - Iboneza ry'abakoresha iboneza (urugero, imiterere cyangwa igenamiterere ry'insanganyamatsiko) <br>
        - Porogaramu yigihe gito cache<br><br>

        <strong>3. Nta Gukurikirana</strong><br>
        Cookies hamwe nububiko bwaho ntibikoreshwa mukwamamaza cyangwa mugice cya gatatu cyo gukurikirana. Amakuru yose yabitswe arimikorere yibikorwa byibanze.<br><br>

        <strong>4. Igenzura</strong><br>
        Mucukumbuzi yamakuru ashobora guhanagurwa igihe icyo aricyo cyose binyuze mumiterere ya mushakisha, izasubiramo iboneza ryaho.
    `,
    cookie_consent_text: "Dukoresha kuki yibanze kugirango tumenye imikorere yurubuga neza, nko gukomeza amasomo yawe akora, kubika ururimi ukunda, nibindi bikoresho byabigenewe.",
    read_policy: "Soma Politiki ya kuki",
    support_title: "Inkunga",
    support_subject_label: "Ingingo",
    support_message_label: "Ubutumwa",
    support_submit_button: "Kohereza Ubutumwa",
    support_hint: "Icyitonderwa: Ibi bizafungura imeri yawe imeri kugirango wohereze ubutumwa.",
    support_success_msg: "Gufungura imeri yawe imeri ...",
    support_error_msg: "Kunanirwa kohereza ubutumwa. Nyamuneka gerageza nyuma.",
    explorer_title: "Ubushakashatsi",
    history_title: "Amateka",
    animation_title: "Animation",
    config_title: "Iboneza",
    tool_mouse: "Hitamo (Ctrl + M)",
    tool_brush: "Brush (Ctrl + B)",
    tool_brush_mode: "Uburyo bwa Toggle Mode (Solid / Clear)",
    tool_eraser: "Gusiba (Ctrl + E)",
    tool_brush_size: "Guhindura Brush Ingano",
    tool_bucket: "Uzuza (Ctrl + F)",
    tool_eyedropper: "Amaso",
    tool_grid: "Imiyoboro (Ctrl + Shift + B)",
    tool_rotate: "Kuzenguruka (Ctrl + Shift + R)",
    tool_flip_h: "Flip H (Ctrl + Shift + H)",
    tool_flip_v: "Flip V (Ctrl + Shift + V)",
    tool_transpose: "Hindura (Ctrl + Shift + T)",
    label_width: "Ubugari",
    label_height: "Uburebure",
    label_frames: "Umubare wa Frames",
    label_animation: "Imiterere ya Animation",
    label_background_color: "Ibara ry'inyuma",
    label_interval: "Intera",
    tool_anim_config: "Iboneza rya Animation",
    label_new_width: "Ubugari bushya",
    label_new_height: "Uburebure bushya",
    label_apply: "Koresha",
    label_colors: "Amabara",
    label_size: "Ingano",
    label_tolerance: "Ubworoherane",
    val_horizontal: "Uhagaritse",
    val_vertical: "Uhagaritse",
    val_sequence: "Urukurikirane",
    val_bounce: "Bounce",
    val_random: "Bisanzwe",
    val_solid: "Birakomeye",
    val_clear: "Biragaragara",
    action_add_sheet: "Urupapuro rushya",
    action_import: "Kuzana ibicuruzwa",
    action_export: "Kohereza hanze",
    action_sort_projects: "Sort",
    sort_date_old: "Umukuru wa mbere",
    sort_date_new: "Agashya Kambere",
    sort_name_az: "Izina (A-Z)",
    sort_name_za: "Izina (Z-A)",
    action_new_sprite: "Gushya",
    action_new_project: "Umushinga mushya",
    modal_save_all_title: "Bika Impinduka zose",
    modal_save_all_desc: "Hitamo umutungo uzigama:",
    modal_save_selected: "Bika Byatoranijwe",
    action_saved: "Yakijijwe",
    modal_create_sprite_title: "Kora Sprite nshya",
    modal_create_project_title: "Kora umushinga mushya",
    modal_add_sheet_title: "Ongeraho Urupapuro rushya",
    modal_rename_sheet_title: "Hindura urupapuro",
    modal_rename_sprite_title: "Hindura izina",
    modal_delete_sprite_title: "Siba Sprite",
    modal_delete_project_title: "Siba Umushinga",
    modal_delete_sheet_title: "Gusiba Urupapuro",
    placeholder_sprite_name: "Izina",
    placeholder_project_name: "Izina",
    placeholder_sheet_name: "Izina",
    placeholder_new_name: "Izina Rishya",
    action_create: "Kurema",
    action_add: "Ongeraho",
    action_rename: "Hindura izina",
    action_duplicate: "Kwigana",
    action_delete: "Siba",
    action_cancel: "Kureka",
    confirm_delete_sprite: "Uzi neza ko ushaka gusiba iyi sprite?",
    confirm_delete_project: "Uzi neza ko ushaka gusiba uyu mushinga? Amasoko yose azavaho.",
    confirm_delete_sheet: "Uzi neza ko ushaka gusiba iyi mpapuro?",
    err_select_sprite: "Nyamuneka hitamo mbere.",
    err_select_project: "Nyamuneka hitamo umushinga.",
    err_name_empty: "Izina ntirishobora kuba ubusa.",
    err_sprite_exists: "Spite ifite iryo zina irahari.",
    err_project_exists: "Umushinga ufite iryo zina urahari.",
    err_no_content: "Nta bikubiyemo kubika.",
    err_no_changes: "Nta gihinduka cyo kuzigama.",
    err_delete_last_sheet: "Ntushobora gusiba urupapuro rwanyuma.",
    err_extract_frames: "Ntushobora gukuramo amakadiri ayo ari yo yose.",
    err_indexeddb: "Kunanirwa kuzigama mu karere. Mucukumbuzi yawe ntishobora gushyigikira IndexedDB.",
    msg_upload_success: "Kuramo Byagenze neza: {0}",
    msg_upload_failed: "Gukuramo birananirana: {0}",
    msg_save_success: "Bika intsinzi.",
    msg_saving: "Kuzigama ...",
    msg_multi_save_result: "Yabitswe {0} umutungo. {1} kunanirwa.",
    menu_title: "Ibikubiyemo",
    menu_save: "Bika",
    menu_save_all: "Bika Byose",
    menu_support: "Inkunga",
    label_local_storage: "Ububiko bwaho",
    label_sign_in: "Injira",
    modal_export_title: "Kohereza ibicuruzwa",
    label_filename: "Izina ryizina",
    label_format: "Imiterere",
    action_export_confirm: "Kohereza hanze",
};

export default translations;
